import React from "react";
import FloatingParticles from "./svg/FloatingParticles";

const LOGIN_BG = `${process.env.PUBLIC_URL}/assets/img/login-bg.jpg`;

const LoginBackground = () => (
  <div className="login-bg-layers">
    <div
      className="login-bg-photo"
      style={{ backgroundImage: `url('${LOGIN_BG}')` }}
      aria-hidden="true"
    />
    <div className="login-bg-overlay" aria-hidden="true" />
    <FloatingParticles />
  </div>
);

export default LoginBackground;
